var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 9.99935C3.33334 7.48519 3.33334 6.22811 4.11439 5.44706C4.89544 4.66602 6.15252 4.66602 8.66668 4.66602H11.3333C13.8475 4.66602 15.1046 4.66602 15.8856 5.44706C16.6667 6.22811 16.6667 7.48519 16.6667 9.99935V11.3327C16.6667 13.8468 16.6667 15.1039 15.8856 15.885C15.1046 16.666 13.8475 16.666 11.3333 16.666H8.66668C6.15252 16.666 4.89544 16.666 4.11439 15.885C3.33334 15.1039 3.33334 13.8468 3.33334 11.3327V9.99935Z",
    stroke: "#1B80FC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 4.66602V3.66602",
    stroke: "#1B80FC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.66602V3.66602",
    stroke: "#1B80FC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66666 8H16.3333",
    stroke: "#1B80FC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.3333C14 13.7015 13.7015 14 13.3333 14C12.9651 14 12.6667 13.7015 12.6667 13.3333C12.6667 12.9651 12.9651 12.6667 13.3333 12.6667C13.7015 12.6667 14 12.9651 14 13.3333Z",
    fill: "#1B80FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.6667C14 11.0349 13.7015 11.3333 13.3333 11.3333C12.9651 11.3333 12.6667 11.0349 12.6667 10.6667C12.6667 10.2985 12.9651 10 13.3333 10C13.7015 10 14 10.2985 14 10.6667Z",
    fill: "#1B80FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.3333C10.6667 13.7015 10.3682 14 10 14C9.63182 14 9.33334 13.7015 9.33334 13.3333C9.33334 12.9651 9.63182 12.6667 10 12.6667C10.3682 12.6667 10.6667 12.9651 10.6667 13.3333Z",
    fill: "#1B80FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10.6667C10.6667 11.0349 10.3682 11.3333 10 11.3333C9.63182 11.3333 9.33334 11.0349 9.33334 10.6667C9.33334 10.2985 9.63182 10 10 10C10.3682 10 10.6667 10.2985 10.6667 10.6667Z",
    fill: "#1B80FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 13.3333C7.33333 13.7015 7.03486 14 6.66667 14C6.29848 14 6 13.7015 6 13.3333C6 12.9651 6.29848 12.6667 6.66667 12.6667C7.03486 12.6667 7.33333 12.9651 7.33333 13.3333Z",
    fill: "#1B80FC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 10.6667C7.33333 11.0349 7.03486 11.3333 6.66667 11.3333C6.29848 11.3333 6 11.0349 6 10.6667C6 10.2985 6.29848 10 6.66667 10C7.03486 10 7.33333 10.2985 7.33333 10.6667Z",
    fill: "#1B80FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlue);
export default __webpack_public_path__ + "static/media/calendar-blue.cb72519272017363566bda0728935289.svg";
export { ForwardRef as ReactComponent };